<template>
  <b-card class="mb-3">
    <div class="overview">
      <div class="d-flex justify-content-between">
        <div class="d-flex flex-column justify-content-between">
          <div
            v-if="order.shopify_order_number"
            class="d-flex flex-column flex-md-row align-items-md-center gap-10">
            <b-button
              variant="none"
              class="collapse-btn rounded"
              :class="visible ? null : 'collapsed'"
              :aria-expanded="visible ? 'true' : 'false'"
              :aria-controls="`collapse-order-${order.id}`"
              v-text="visible ? '-' : '+'"
              @click="visible = !visible"
            />
            <a v-if="isDashboard" :href="`/admin/orders/shopify/${order.shopify_order_number}`" target="_blank" class="font-size-initial">
              #{{ order.shopify_order_number }}
            </a>
            <span v-else @click="visible = !visible" class="font-size-initial text-primary">#{{ order.shopify_order_number }}</span>
            <span class="font-size-small text-muted">{{ order.created_at }}</span>
          </div>
          <div
            v-else
            class="d-flex flex-column flex-md-row align-items-md-center gap-10">
            <b-button
              variant="none"
              class="collapse-btn rounded"
              :class="visible ? null : 'collapsed'"
              :aria-expanded="visible ? 'true' : 'false'"
              :aria-controls="`collapse-order-${order.id}`"
              v-text="visible ? '-' : '+'"
              @click="visible = !visible"
            />
            <a v-if="isDashboard" :href="`/admin/orders/${order.serial_number}`" target="_blank" class="font-size-initial">
              #L{{ order.serial_number }}
            </a>
            <span v-else @click="visible = !visible" class="font-size-initial text-primary">#L{{ order.serial_number }}</span>
            <span class="font-size-small text-muted">{{ order.created_at }}</span>
          </div>
          <div>
            <span class="font-size-initial">Total:</span>
            <span class="font-size-large font-weight-bold">{{ totalAmount }}</span>
          </div>

          <div>
            <span class="font-size-initial">Items:</span>
            <span class="font-size-large font-weight-bold">{{ numOfItems }}</span>
          </div>
        </div>

        <div class="d-flex flex-column gap-12 border-left pl-3 gap-10">
          <div>
            <b-badge pill :variant="statusVariant">{{ order.status }}</b-badge>
          </div>

          <div>
            <span>Fulfillment Status:</span>
            <span :class="[shipmentVariant]">{{ order.shipment_status }}</span>
          </div>

          <div class="d-flex flex-column flex-md-row gap-10">
            <b-button
              class="text-uppercase font-weight-bold"
              variant="primary"
              @click="$emit('print', order)"
            >
              Print invoice
            </b-button>
            <b-button
              class="text-uppercase font-weight-bold"
              variant="primary"
              @click="$emit('reorder', { id: order.id })"
            >
              Re-order
            </b-button>
          </div>
        </div>
      </div>
    </div>

    <div class="details">
      <b-collapse :id="`collapse-order-${order.id}`" v-model="visible">
        <hr />
        <div class="d-flex align-items-center">
          <i class="las la-shipping-fast font-size-large"></i>
          <span class="mx-2">Shipping Method:</span>
          <span>{{ order.shipping_method ?? '-' }}</span>
        </div>

        <hr />
        <div>
          <ul class="list-inline">
            <products-list-item v-for="product in order.order_products" :key="product.id" :product="product.product" :qty="product.qty" />
          </ul>
        </div>
      </b-collapse>
    </div>
  </b-card>
</template>

<script>
import ProductsListItem from '@core/components/products/ProductsListItem'
import { currencyFormat } from '@core/helpers/configHelper'
import { shipmentStatus, orderStatus } from '@core/config/orders'

export default {
  name: 'OrderCard',
  props: { order: { type: Object, required: true }, isDashboard: { type: Boolean } },
  components: { ProductsListItem },
  computed: {
    totalAmount() {
      return `$${currencyFormat(this.order.total.amount)} ${this.order.total.currency}`
    },
    numOfItems() {
      return this.order.order_products.length
    },
    statusVariant() {
      if (this.order.status === orderStatus['PAID']) return 'success'
      if (this.order.status === orderStatus['CANCELED']) return 'danger'
      if (this.order.status === orderStatus['REFUNDED']) return 'secondary'
      if (
        [orderStatus['PARTIALLY_PAID'], orderStatus['AWAITING_PAYMENT'], orderStatus['PARTIALLY_REFUNDED']].includes(
          this.order.status
        )
      )
        return 'warning'
    },
    shipmentVariant() {
      if (this.order.shipment_status === shipmentStatus['SHIPPED']) return 'text-success'
      return 'text-muted'
    }
  },
  data() {
    return {
      visible: false
    }
  },
  watch: {
    order: {
      immediate: true,
      handler(newVal) {
        this.order.total.value = currencyFormat(this.order.total.amount)
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.collapse-btn {
  font-size: x-large;

  width: 24px;
  height: 24px;
  border: 1px solid;
  border-width: medium;
  padding: 5px 10px 4px;

  display: inline-flex;
  align-items: center;
  justify-content: center;
}
</style>
